import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox, VBox } from '../../../../../components/Box';
import { selectInvoice } from '../../../../Invoices/selectors';
import { getPropByName } from '../../../../../utils/props';
import { selectAddressTypes } from '../../../../Address/selectors';
import { formatCurrency } from '../../../../../utils/string';
import { VEHICLE_TAX_TYPE } from '../.././../constants';
import * as converter from 'number-to-words';
import { SaleAgreementFooter } from '../SaleAgreementFooter';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_COMPANY } from '../../../../Companies/constants';
import env, { clientId } from "../../../../../env";
import { AppClientId } from "../../../../Shared/constants";
import { BankAccount } from '../../../../../components/Icon';

let client_name = ''
let par2 = ''
let bank_account = ''
let sign_city = ''
let court_city = ''
let website = ''


const Container = styled.div`
  height: 100%;
  font-family: 'Open sans', sans-serif;

  line-height: 1.2;
  font-size: 19px;
  padding: 25px 30px 0px 30px;
  position: relative;

  .section {
    margin-bottom: 6px;
  }

  .subtitle {
    font-size: 24px;
  }

  width: 100%;
  max-width: 1240px;
  background-color: white;
  color: black;

  .title {
    margin-bottom: 24px;
    fontsize: 450px;
    text-decoration: underline;
  }
`;

const MainList = styled.ol`
  margin: 0 0 20px 0;
  font-weight: 600;

  h2 {
    font-size: 18px;
  }

  .subtitle {
    font-size: 14px;
    font-weight: 400;
  }
`;

const SecondaryList = styled.ol`
  margin: 0 0 20px 0;
  font-weight: 400;
`;

const DataString = styled.span`
  font-weight: 600;
  color: ${props => (props.red ? 'red' : 'black')};
`;

const Header = styled.div`
  width: 100%;
  margin-bottom: 36px;
  padding: 6px 24px;
  background-color: #44546a;
  color: #fff;
`;

const Body = styled.div`
  padding: 0px 45px;
`;

const Footer = styled(HBox)`
width: 95%;
font-size: 13px;
position: absolute;
bottom: ${props => `${props.bottom}px`};
left: 0;
right:0;
padding 0 30px;
justif-content: center;
align-items: center;
`;

const DocField = styled(HBox)`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '3px')};
  height: ${props => (props.height ? props.height : '24px')};

  .label {
    height: 100%;
    padding-left: 6px;
    width: ${props => (props.labelOnly ? '100%' : props.large ? '220px' : props.wideLabel ? '70%' : '50%')};
    background-color: ${props => (props.lightgrey ? '#b8b9be' : '#c2c8e2')};
    font-weight: ${props => !props.strongValue && '600'};
  }
  .value {
    width: ${props => (props.withoutLabelField ? '100%' : props.mediumValueWide ? '60%' : props.large ? '80%' : '50%')};
    font-weight: ${props => props.strongValue && '600'};
    height: 100%;
    padding-left: 10px;
    background-color: #f4f7fe;
  }
`;

const SignatureTable = styled(VBox)`
  width: ${props => (props.width ? props.width : '100%')};
  .table-header {
    text-align: center;
    background-color: #b8b9be;
    border: 1px solid #fff;
  }

  .table-box {
    height: 50px;
    .labelCell {
      background-color: #b8b9be;
      width: 30%;
      height: 100%;
      border: 1px solid #fff;
      padding-left: 8px;
    }
    .valueCell {
      background-color: #f4f7fe;
      width: 70%;
      height: 100%;
      border: 1px solid #fff;
      padding-left: 8px;
    }
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class ExportSaleAgreementComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get outgoingCompany() {
    return this.props.invoice?.outgoingCompany;
  }

  get homeAddress() {
    const homeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;

    const homeAddress = this.outgoingCompany?.addresses.find(address => address?.type?.id == homeId);

    return homeAddress;
  }

  get company() {
    return this.props.company;
  }

  get address() {
    return this.props.address;
  }

  get financialContact() {
    const financialContactId = this.getCompanyPropValue('relation_financial_contact_id');
    const user = this.company?.users?.find(u => u.id == financialContactId);
    return user;
  }

  get companyLabel() {
    let label = `${this.getCompanyPropValue('name') ?? ''}`;

    return this.address?.company_name || label;
  }

  get textByTaxType() {
    let text =
      this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW
        ? 'De levering betreft een intracommunautaire levering conform artikel 139, lid 1, Richtlijn 2006/112. De Verkoper moet de intracommunautaire levering opnemen in zijn BTW-aangifte per afnemer bij de opgaaf ICL. De Koper verklaart door ondertekening van deze overeenkomst dat de intracommunautaire verwerving wordt opgenomen in zijn BTW-aangifte;'
        : 'De levering betreft een levering onder de bijzondere regeling – gebruikte goederen conform de artikelen 28b tot en met 28i Wet op de omzetbelasting 1968 en hoofdstuk 4 van Titel XII van de EU BTW-richtlijn;';
    return text;
  }

  getCompanyPropValue(name) {
    return getPropByName(this.company, name);
  }

  formatString(str) {
    return <strong color="red">{str ?? ''}</strong>;
  }

  render() {
    // if (this.props.companyWork) return <Loader small />;
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;
    console.log({ company: this.company, address: this.address }, 'COMPANY');
    return (
      <Container>
        <Body>
          <Header>
            <HBox center vCenter>
              <h1>KOOPOVEREENKOMST</h1>
            </HBox>
          </Header>
          <MainList type="I">
            <li>
              <h2>DE ONDERGETEKENDEN</h2>
              <SecondaryList>
                <li>
                  <DataString red>{this.getCompanyPropValue('name')}</DataString>
                  gevestigd te <DataString red>{this.address?.city}</DataString> aan het adres{' '}
                  <DataString red>{this.address?.addressLine1}</DataString> met BTW-nummer{' '}
                  <DataString red>{this.getCompanyPropValue('BTW_number')}</DataString> rechtsgeldig vertegenwoordigd door{' '}
                  <DataString red>{`${getPropByName(this.financialContact, 'name') ?? ''} ${getPropByName(
                    this.financialContact,
                    'surname',
                  ) ?? ''}`}</DataString>{' '}
                  te noemen <DataString>“Koper”</DataString>;
                </li>
                <li>
                  {par2}{' '}
                  <DataString>Verkoper”</DataString>; de partijen 1 en 2 hierna gezamenlijk te noemen{' '}
                  <DataString>"Partijen"</DataString> en elk afzonderlijk tevens een <DataString>"Partij"</DataString>{' '}
                </li>
              </SecondaryList>
              <SecondaryList type="A">
                <li>
                  Verkoper is eigenaar van het voertuig <DataString red>{vehicle.brand_name}</DataString>{' '}
                  <DataString red>{vehicle.model_name}</DataString> met het chassisnummer{' '}
                  <DataString red>{vehicle.vin}</DataString> hierna aangeduid als: het <DataString>“Voertuig”</DataString>;
                </li>
                <li>
                  Partijen overeenstemming hebben bereikt over koop, verkoop en overdracht van het voertuig, welke
                  overeenstemming partijen nader wensen uit te werken onder de voorwaarden zoals vastgelegd in deze
                  overeenkomst, hierna: de <DataString>“Overeenkomst”</DataString>;
                </li>
                <li>
                  Verkoper sluit naar beste weten en te goeder trouw de Overeenkomst met Koper, waarbij Koper erkent dat
                  Verkoper niet bekend is met verborgen technische, feitelijke en/of juridische status van het voertuig en
                  Koper bevestigt dat hij Verkoper niet aansprakelijk zal houden uit welke hoofde in verband met de
                  Overeenkomst;
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>KOOP EN VERKOOP</h2>
              <SecondaryList type="I">
                <li>
                  <span>Koper koopt van Verkoper, gelijk Verkoper aan Koper verkoopt het voertuig:</span>
                  <HBox>
                    <VBox>
                      {['brand_name', 'model_info', 'vin', 'date_first_allowance'].map(type => {
                        return (
                          <DocField key={type} large strongValue>
                            <div className="label">{type}</div>
                            <div className="value">
                              <DataString red>{vehicle[type] ?? ''}</DataString>
                            </div>
                          </DocField>
                        );
                      })}
                    </VBox>
                    <VBox>
                      {['model_name', 'fuel_type', 'regplate', 'mileage'].map(type => {
                        return (
                          <DocField key={type} large strongValue>
                            <div className="label">{type}</div>
                            <div className="value">
                              <DataString red>{vehicle[type] ?? ''}</DataString>
                            </div>
                          </DocField>
                        );
                      })}
                    </VBox>
                  </HBox>
                </li>
                <li>
                  Koper verklaart met het voertuig bekend te zijn zoals omschreven in het inspectierapport en erkent dat
                  Verkoper geen enkele garantie geeft voor de kwaliteit en/of status van het voertuig;
                </li>
                <li>
                  Het Voertuig wordt verkocht en overgedragen in de staat waarin het zich ten tijde van de overeenkomst
                  bevindt, inclusief alle zichtbare en onzichtbare gebreken en zonder dat Verkoper tot enige garantie of
                  vrijwaring is gehouden;
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>KOOPSOM EN BETALING</h2>
              <SecondaryList type="I">
                <li>
                  De koopprijs bedraagt{' '}
                  <DataString red>{formatCurrency(vehicle?.outgoing_financial_total_amount)}</DataString> hierna de:{' '}
                  <DataString>“Koopprijs”</DataString>;
                </li>

                <li>{this.textByTaxType}</li>
                <li>
                  De betaling moet na factuurdatum per omgaande voldaan worden;
                  <p>
                    Betaling vindt plaats uitsluitend met een bankoverschrijving uiterlijk <DataString>twee</DataString>{' '}
                    dagen voor het moment van leveren op het bankrekeningnummer van de verkoper{' '}
                    <DataString>{BankAccount}</DataString> ten name van <DataString>{client_name}</DataString>.
                  </p>
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>BORGSTELLING</h2>
              <SecondaryList type="I">
                <li>
                  De koper is in het kader van deze overeenkomst een bedrag aan borg verschuldigd jegens de verkoper. Dit ter
                  dekking voor de zekerheid dat het voertuig duurzaam wordt geregistreerd in{' '}
                  <DataString red>{this.address?.city}</DataString> en op naam van{' '}
                  <DataString red>{getPropByName(this.financialContact, 'name') ?? ''}</DataString>;
                </li>
                <li>
                  Het bedrag aan verschuldigde borg is vastgesteld op{' '}
                  <DataString red>{formatCurrency(vehicle?.bpm_guarantee_sum)}</DataString> zegge ”
                  <DataString red>{converter.toWords(vehicle?.bpm_guarantee_sum ?? 0)}</DataString>” Euro;
                </li>
                <li>
                  Voor het betreffende bedrag ontvangt u een factuur, deze factuur dient u per omgaande te voldoen doch in
                  ieder geval voor het moment van leveren;
                </li>
                <li>
                  Het borg bedrag zal geheel aan de Koper worden teruggestort zodra de Verkoper in het bezit is van de
                  duurzame registratie conform de voorwaarden zoals beschreven in artikel I en II. Is er niet voldaan aan
                  deze voorwaarden, heeft de Verkoper het recht om het borgbedrag te behouden.
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>LEVERING VAN HET VOERTUIG</h2>
              <SecondaryList type="I" style={{ marginBottom: '350px' }}>
                <li>
                  De feitelijke overdracht en levering van het voertuig vindt plaats door bezitsverschaffing en door
                  ondertekening van deze overeenkomst;
                </li>
                <li>
                  Het voertuig moet uiterlijk binnen 10 dagen na betaling worden afgehaald. Alvorens het voertuig kan worden
                  afgehaald dient er een door koper ondertekende en rechtsgeldige afhaalbevestiging met betreffende volmacht
                  minimaal 24 uur vooraf te worden overlegd aan Verkoper
                </li>
                <li>Het voertuig mag door een transportbedrijf met een volledig ingevuld CMR-document worden afgehaald.</li>
                <li>
                  Na ontvangst van het CMR-document inclusief handtekening voor aankomst worden de voertuigdocumenten door de
                  Verkoper via DHL aangetekend verstuurd;
                </li>
                <li>
                  De verkoper verklaart dat het voertuig zijn eigendom is en vrij is van lasten, beslagen en dergelijke;
                </li>
                <li>
                  De koper kan de overeenkomst zonder tussenkomst van de rechter ontbinden indien blijkt dat de auto na koop
                  en voor de levering niet overstemt met de staat van het voertuig zoals is vastgelegd in het
                  inspectierapport;
                </li>
              </SecondaryList>
            </li>
          </MainList>
          <Footer page={1} bottom={1754}>
            <SaleAgreementFooter page={'1-2'} />
          </Footer>
        </Body>
        {/* Page 2 */}

        <Body>
          <Header>
            <HBox center vCenter>
              <h1>KOOPOVEREENKOMST</h1>
            </HBox>
          </Header>
          <MainList type="I" start={6}>
            <li>
              <h2>OVERIGE BEPALINGEN </h2>
              <SecondaryList type="I">
                <li>Deze koopovereenkomst dient uiterlijk binnen 2 dagen na ontvangst te zijn ondertekend door koper;</li>
                <li>
                  Verkoper heeft het recht de koop te ontbinden wanneer er niet wordt voldaan aan de voorwaarden zoals deze
                  zijn beschreven in deze koopovereenkomst;
                </li>
                <li>Op deze koopovereenkomst is het Nederlandse recht van toepassing; </li>
                <li>
                  Op deze koopovereenkomst zijn onze algemene leveringsvoorwaarden van toepassing, deze staan op {website} gepubliceerd en worden op verzoek kosteloos ter beschikking gesteld;
                </li>
                <li>
                  Op deze koopovereenkomst is onze privacy policy van toepassing, deze staat op {website} gepubliceerd;
                </li>
                <li>
                  Alle uit deze overeenkomst voortvloeiende geschillen worden in eerste aanleg behandeld door de rechtbank {court_city}.{' '}
                </li>
              </SecondaryList>
            </li>
            <li>
              <h2>ONDERTEKENING</h2>
              <span className="subtitle">Aldus in tweevoud overeengekomen en overtekend: </span>
              <HBox>
                <SignatureTable width={'50%'}>
                  <HBox center className="table-header">
                    <DataString>In te vullen door Verkoper</DataString>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Plaats: </div>
                    <div className="valueCell">{sign_city}</div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Datuum:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Naam:</div>
                    <div className="valueCell"></div>
                  </HBox>

                  <HBox className="table-box">
                    <div className="labelCell">Handtekening:</div>
                    <div className="valueCell"></div>
                  </HBox>
                </SignatureTable>
                <SignatureTable width={'50%'}>
                  <HBox center className="table-header">
                    <DataString>In te vullen door Koper</DataString>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Plaats: </div>
                    <div className="valueCell">{this.address?.city}</div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Datuum:</div>
                    <div className="valueCell"></div>
                  </HBox>
                  <HBox className="table-box">
                    <div className="labelCell">Naam:</div>
                    <div className="valueCell">
                      Namens <DataString red>{this.companyLabel}</DataString>
                    </div>
                  </HBox>

                  <HBox className="table-box">
                    <div className="labelCell">Handtekening:</div>
                    <div className="valueCell"></div>
                  </HBox>
                </SignatureTable>
              </HBox>
            </li>
          </MainList>
          <Footer page={2} bottom={0}>
            <SaleAgreementFooter page={'2-2'} />
          </Footer>
        </Body>
      </Container>
    );
  }
}

ExportSaleAgreementComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
    companyWork: selectWork(REQUEST_COMPANY),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ExportSaleAgreement = compose(withConnect, withRouter)(ExportSaleAgreementComp);
